// ---------------------------------------------------------------------------
// Filtros de fecha de la asistencia (#1143): quincena, mes o un rango libre.
//
// Misma semántica que Mis pagos: 1.ª quincena = días 1–15; 2.ª = 16–fin de mes;
// mes = mes completo. Las fechas son del calendario LOCAL: con la hora UTC,
// quien consulta de noche en México vería ya «mañana».
// ---------------------------------------------------------------------------
export type PeriodMode = "fortnight" | "month";
export type Half = "Q1" | "Q2";

const pad = (n: number) => String(n).padStart(2, "0");

/** Hoy en el calendario local, YYYY-MM-DD. */
export function localToday(now: Date = new Date()): string {
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

/** Último día del mes `YYYY-MM` (28–31). */
export function lastDayOfMonth(month: string): number {
  const [y, m] = month.split("-").map(Number);
  return new Date(y, m, 0).getDate();
}

/** Rango inclusivo de una quincena o de un mes. */
export function periodRange(
  mode: PeriodMode,
  month: string,
  half: Half,
): { from: string; to: string } {
  const end = `${month}-${pad(lastDayOfMonth(month))}`;
  if (mode === "month") return { from: `${month}-01`, to: end };
  return half === "Q1"
    ? { from: `${month}-01`, to: `${month}-15` }
    : { from: `${month}-16`, to: end };
}

/** Quincena en curso: la 1.ª hasta el día 15. */
export function currentHalf(today: string = localToday()): Half {
  return Number(today.slice(8, 10)) <= 15 ? "Q1" : "Q2";
}
